import { PropertyCard } from '@zillow/constellation-10';

const PropertyCardSkeleton = () => (
  <PropertyCard
    appearance="horizontal"
    loading={true}
    css={{
      height: '100%',
      minHeight: '86px',
      // eslint-disable-next-line curly-quotes/no-straight-quotes
      '& > [data-c11n-component="PropertyCard.Body"]': {
        height: '100%',
      },
      // eslint-disable-next-line curly-quotes/no-straight-quotes
      '& > [data-c11n-component="PropertyCard.Body"] > [data-c11n-component="PropertyCard.PhotoWrapper"] > [data-c11n-component="PropertyCard.PhotoBody"]':
        {
          minHeight: 'auto',
        },
    }}
    data={{
      dataArea1: { children: <>&nbsp;</>, css: { width: '60%' } },
      dataArea2: { children: <>&nbsp;</>, css: { width: '40%' } },
    }}
  />
);

export { PropertyCardSkeleton };
